import React from 'react';
import { CirclesWithBar } from 'react-loader-spinner';

const LoaderScreen = ({ height = "83vh" }) => {
  return (
    <div className={`w-full flex items-center justify-center mt-12`} style={{ height }}>
      <CirclesWithBar
        height="100"
        width="100"
        color="#FF6C2F"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        outerCircleColor=""
        innerCircleColor=""
        barColor=""
        ariaLabel="circles-with-bar-loading"
      />
    </div>
  );
};

export default LoaderScreen;
